module.exports = __webpack_public_path__ + "static/media/AUTENTIFICACIÓN.6c31a0f6.svg";